document.addEventListener ('DOMContentLoaded', function () {

    if (document.getElementsByClassName ('careers-slidershow').length) {
        new Splide ('.careers-slidershow', {
            type   : 'loop',
            gap: '20px',
            padding: '20%',
            pagination: false,
            autoplay: true,
            interval: 5000,
            drag: false,
            arrows: false,
            speed: 4000,
            breakpoints: {
                712: {
                    padding: '10%'
                }
            }
        }).mount ();
    }
});